module.exports = __webpack_public_path__ + "media/images/twitter/twitter_embed_code-5c07a41bcb780d9c4c6ad3c81aabfa16.png";